// React
import React, { Component } from "react";
import { connect } from "react-redux";
// Routing
import { withRouter } from "react-router-dom";
// Material
import { CircularProgress, Divider } from "@material-ui/core";
// Vendor
import {
  showNotify,
  updateLimitsIntegrations
} from "vendor/application/disptach";
// Infrastructure
import { IntegrationsAPI } from "api/application/Integrations";
// Application
import { getAircallBody } from "vendor/application";
import { ElementsHandleAPI } from "vendor/application/handleMethods";
// Translations
import { withTranslation } from "react-i18next";
// Components
import { Button } from "@components/Input";
import { ElementsCustom } from "@components/Elements";
// SVG
import { channelsSvg } from "assets";
import { arrowRightSvg } from "@assets";

class Create extends Component {
  constructor(props) {
    super(props);
    this.state = {
      aircall: getAircallBody(),
      integration: false
    };
  }

  updateElement = (e, type, i) => {
    const { aircall } = this.state;
    const obj = new ElementsHandleAPI(aircall.info, e.target.value, type, i);
    obj.updateObj();
    this.setState({ aircall: aircall });
  };

  return = () => {
    const { history } = this.props;
    const { actualProject } = this.props.data;
    history.push(`/${actualProject.id}/integrations/aircall`);
  };

  postIntegration = async (e) => {
    e.preventDefault();
    const { access, actualProject } = this.props.data;
    const { history } = this.props;
    const { aircall } = this.state;

    try {
      const obj = new IntegrationsAPI(
        actualProject.id,
        access,
        this.props,
        aircall
      );
      let integration = await obj.post_integration();

      this.props.dispatch(
        showNotify({
          message: "integrations",
          type: "create",
          severity: "success"
        })
      );

      this.props.data.limitsIntegrations.aircall.existIntegration = true;
      this.props.dispatch(
        updateLimitsIntegrations(this.props.data.limitsIntegrations)
      );

      history.push(
        `/${actualProject.id}/integrations/aircall/edit/${integration.id}`
      );
    } catch (err) {
      this.props.dispatch(showNotify({ message: err, severity: "error" }));
    }
  };

  render() {
    const { aircall } = this.state;
    const { t } = this.props;
    const { isSending, limitsIntegrations } = this.props.data;
    const isAvailable = limitsIntegrations?.aircall?.available !== false;
    return (
      aircall && (
        <div className={"cen_integrations"}>
          <div className={"header"}>
            <div className={"header_content"}>
              <div onClick={() => this.return()} className={"header_action"}>
                {arrowRightSvg()}
              </div>
              <div className={"header_image"}>{channelsSvg("aircall")}</div>
              <div className={"header_title"}>
                <span className={"title"}>
                  {t("integrations:channels.aircall.title")}
                </span>
                <span className={"description"}>
                  {t("integrations:categories.customer")}
                </span>
              </div>
            </div>
            <div className={"header_actions"}>
              {isSending ? (
                <Button
                  type={"primary"}
                  disabled
                  text={<CircularProgress size={21} />}
                />
              ) : (
                <Button
                  type={"primary"}
                  disabled={!isAvailable}
                  text={t("integrations:create.action_button")}
                  onClick={(e) => this.postIntegration(e)}
                />
              )}
            </div>
          </div>
          {!isAvailable && (
            <div className={"integration_alert"}>
              <span>{t("integrations:channels.aircall.requires_centridesk")}</span>
            </div>
          )}
          <div className={"integration"}>
            {/* API ID */}
            <ElementsCustom
              t={t}
              type={"aircall"}
              input_type={"input"}
              element_type={"api_id"}
              element={aircall.info.api_id}
              updateElement={this.updateElement}
            />
            <Divider />
            {/* API TOKEN */}
            <ElementsCustom
              t={t}
              type={"aircall"}
              input_type={"input"}
              element_type={"api_token"}
              element={aircall.info.api_token}
              updateElement={this.updateElement}
            />
            <Divider />
            {/* WEBHOOK TOKEN */}
            <ElementsCustom
              t={t}
              type={"aircall"}
              input_type={"input"}
              element_type={"webhook_token"}
              element={aircall.info.webhook_token}
              updateElement={this.updateElement}
            />
          </div>
        </div>
      )
    );
  }
}

const mapStateToProps = (state) => {
  return {
    data: state
  };
};

const create = connect(mapStateToProps)(Create);

export default withTranslation(["commons", "common"])(withRouter(create));
